export default __webpack_public_path__ + "static/media/UIResetPasswordBackground.70cd839d.png";